function search() {
  function getSearchResults(input, output) {
    const type = "product,collection,page,article";
    const fields = "title,product_type,variants.title,variants.sku,vendor,tag,body";
    const limit = "8";

    fetch(
      `/search/suggest?q=${input}&resources[type]=${type}&resources[fields]=${fields}&resources[limit]=${limit}&section_id=predictive-search`
    )
      .then((res) => {
        if (!res.ok) {
          const error = new Error(res.status);
          throw error;
        }
        return res.text();
      })
      .then((text) => {
        const markup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        output.innerHTML = markup;
      })
      .catch((error) => {
        throw error;
      });
  }

  return {
    terms: null,

    handleChange() {
      const { input, output } = this.$refs;
      if (input.value != "") {
        getSearchResults(input.value, output);
      } else {
        this.terms = null;
      }
    },
  };
}
